<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{'Scheme Holdings'}} - {{mfSCHCode}}</strong>
        </div>
        <div class="col-md-5">          
        </div>
        <div class="col-md-1">
          <!-- <goback></goback> -->
          <div class="pull-right">
            <router-link class="btn btn-sm" :to="'/mutual-funds/rawdata'"><i class="fa fa-caret-left"></i> Go Back</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5" >
            <div class="col-md-3">
              <div class="form-group">
                <v-select
                  :options="durDateList"
                  :placeholder="'Select Date'"
                  v-model="durDate"
                  @input="getDateData($event)"
                  ></v-select>
              </div>
            </div>
          </div>
        <div class="mb5"></div>
        <div class="row mb5">
          <div class="col-md-10"></div>
          <div class="col-md-2">
            <download :tableId="rawDataType" :fileName="rawDataType"></download>
          </div>
        </div>
        <div class="table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields.length">
          <table :id="rawDataType" class="table table-bordered fonts11 app-inner">
            <thead>
              <tr>
                <th>Sr.</th>
                <th
                  class="data-cell"
                  v-for="(field, index, key) in tableFields"
                  v-bind:key="'field'+field.rowind+index+key"
                >{{field.name}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                <td>
                  <span v-if="rawDataType=='schemes'">
                    <span v-if="page>1">{{(perPage * (page-1)) + (ind+1)}}</span>
                    <span v-else>{{ind+1}}</span>
                  </span>
                  <span v-else>{{ind+1}}</span>
                </td>
                <td
                  v-for="(cl, index) in tableFields"
                  v-bind:key="index+'cldata'+cl.title"
                >
                <span v-if="cl.isLink">
                  <a class="a-btn">{{tr[cl.title]}}</a>
                </span>
                <span v-else>
                  <span v-if="cl.datatype=='date'">{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                  <span v-else>{{(tr[cl.title])? tr[cl.title]: '-'}}</span>
                </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mb5" v-if="!tableFields.length">
          <div class="col-md-12"><div class="alert alert-danger" role="alert">No data found!</div></div>
        </div>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import Datepicker from "vuejs-datepicker";

import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { rawMixins } from "../../assets/mixins/rawMixins.js";

export default {
  components: { VueTabs, VTab, Datepicker },
  mixins: [commonMixins, rawMixins],
  created() {
    console.log('PARAM', this.$route.params.id);
    if(this.$route.params.id) {
      this.showSchemeHoldings(this.$route.params.id);
      this.mfSCHCode = this.$route.params.id;
    } else {
      this.tableFields, this.rawData = [];
    }
    console.log("Rawtype", this.rawDataType, this.mfSCHCode);
  },
  methods: {
    showSchemeHoldings(mfcode) {
      console.log('mfcode', mfcode);
      this.rawData = [];
      this.tableFields = [];
      let myself = this;
      var APIUrl = this.rawDataApi + 'scheme-holdings/' + mfcode;
      if(this.durDate!=null) {
        APIUrl = APIUrl + '?date=' + this.getYMDDate(this.durDate);
      }
      http.get(
        APIUrl,
        {},
        (error, response) => {
          console.log("Response", response.data);
          if(response.status == 'success') {
            this.rawData = response.data.length > 0 ? response.data : [];
            this.durDateList = response.date.length > 0 ? response.date.reverse() : [];
                this.durDateList.map((date, index) => {
                  this.durDateList[index] = date.split('T')[0];
                });
                
            console.log('this.durDateList >>>', this.durDateList)
            console.log(this.rawData);
            if(response.data.length>0) {
              var tableKeys = Object.keys(this.rawData[0]);
              tableKeys.forEach((tf, key) => {
                if(tf != '_id') {
                  this.tableFields.push({
                    title: tf,
                    name: this.getLabel(tf),
                    rowind: 0,
                    isLink: 0,
                    datatype: (tf=='INVDATE')? 'date': '',
                    sort_order: (tf=='SCH_NAME')? 1
                    : (tf=='MF_SCHCODE')? 2
                    : (tf=='TYPE')? 3
                    : (tf=='TYPECODE')? 4
                    : (tf=='IIND_NAME')? 5
                    : (tf=='INVDATE')? 6
                    : (tf=='CO_CODE')? 7
                    : (tf=='CO_NAME')? 8 
                    : (tf=='MKTVALUE')? 7
                    : (tf=='NO_SHARES')? 9
                    : (tf=='PERC_HOLD')? 10
                    : 99
                  });
                }
              });
              this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
            }
          // console.log("this.rawData", this.rawData);
          }
        });
    },
    getDateData(e) {
      console.log("Date Selected", e);
      this.durDate = e;
      if(this.durDate && this.durDate != null)
        this.showSchemeHoldings(this.mfSCHCode);
    },
  },
  data() {
    return {
      durDate: null,
      // durDate: new Date().setDate(new Date().getDate() - 1),
      disabledDates: {
        from: new Date(new Date().setDate(new Date().getDate() - 1))
      },
      tableFields: [],
      rawDataType: "scheme-holdings",
      rawDataApi: "mutual-funds/",
      rawData: [],
      durDateList: [],
      mfSCHCode: ''
    };
  },
  computed: {
    // mfHoldingData: function() {
    //   return this.rawData.filter(function(row, index) {
    //     return index !== "_id" && index !== "co_code";
    //   });
    // },
    // keyFinancialRatios: function(){
    //   return (this.rawData.length > 0 && this.rawData[0]['keyfinancialratiolist'])? this.rawData[0]['keyfinancialratiolist']: [];
    // }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/holdings.vue